import { Navigate } from "react-router";
import { Outlet, Route, Routes } from "react-router-dom";

import { PageError } from "components/layout";
import { ExtendedRoute } from "containers/ExtendedRoute";
import { RedirectById } from "containers/Layout/SideMenu/redirect/RedirectById";
import { RedirectDependingOnRoles } from "containers/Layout/SideMenu/redirect/RedirectDependingOnRoles";
import { RestrictedArea, ROLES } from "containers/Permissions";
import { trans } from "src/translations";

import {
  TiVoClientTypeAdd,
  TiVoClientTypeApplications,
  TiVoClientTypeDetails,
  TiVoClientTypeEdit,
  TiVoOemAdd,
  TiVoOemApplications,
  TiVoOemDetails,
  TiVoOemEdit,
} from "./DeviceDetails";
import { TiVoDevicesList } from "./DevicesList/TiVoDevicesList";

export function TiVoDevicesRoute() {
  return (
    <RestrictedArea
      allowed={[ROLES.tivoDevices.admin, ROLES.tivo.preview]}
      fallbackChildren={
        <PageError pageHeader={null} error={{ isForbidden: true }} />
      }
    >
      <Routes>
        <Route index element={<RedirectDependingOnRoles />} />
        <Route
          path="/list"
          element={<RedirectById path="/tivodevices/list/main" />}
        />
        <Route
          path="/list/:tabId"
          element={
            <ExtendedRoute
              name={trans.TIVO_DEVICES_LIST_ROUTE_NAME()}
              component={TiVoDevicesList}
            />
          }
        />
        <Route
          path="/applications/:platformId/:oemId/:clientTypeId"
          element={
            <ExtendedRoute
              name={trans.TIVO_DEVICES_CLIENT_APPLICATIONS_ROUTE_NAME()}
              component={TiVoClientTypeApplications}
            />
          }
        />
        <Route
          path="/applications/:platformId/:oemId"
          element={
            <ExtendedRoute
              name={trans.TIVO_DEVICES_OEM_APPLICATIONS_ROUTE_NAME()}
              component={TiVoOemApplications}
            />
          }
        />
        <Route
          path="/details/:platformId/:oemId/:clientTypeId"
          element={
            <ExtendedRoute
              name={trans.TIVO_DEVICES_CLIENT_DETAILS_ROUTE_NAME()}
              component={TiVoClientTypeDetails}
            />
          }
        />
        <Route
          path="/details/:platformId/:oemId"
          element={
            <ExtendedRoute
              name={trans.TIVO_DEVICES_OEM_DETAILS_ROUTE_NAME()}
              component={TiVoOemDetails}
            />
          }
        />
        <Route
          element={
            <RestrictedArea
              allowed={[ROLES.tivoDevices.admin]}
              fallbackChildren={
                <PageError pageHeader={null} error={{ isForbidden: true }} />
              }
            >
              <Outlet />
            </RestrictedArea>
          }
        >
          <Route
            path="/create/:platformId/:oemId"
            element={
              <ExtendedRoute
                name={trans.TIVO_DEVICES_CLIENT_ADD_ROUTE_NAME()}
                component={TiVoClientTypeAdd}
              />
            }
          />
          <Route
            path="/create/:platformId"
            element={
              <ExtendedRoute
                name={trans.TIVO_DEVICES_OEM_ADD_ROUTE_NAME()}
                component={TiVoOemAdd}
              />
            }
          />
          <Route
            path="/edit/:platformId/:oemId/:clientTypeId"
            element={
              <ExtendedRoute
                name={trans.TIVO_DEVICES_CLIENT_EDIT_ROUTE_NAME()}
                component={TiVoClientTypeEdit}
              />
            }
          />
          <Route
            path="/edit/:platformId/:oemId"
            element={
              <ExtendedRoute
                name={trans.TIVO_DEVICES_OEM_EDIT_ROUTE_NAME()}
                component={TiVoOemEdit}
              />
            }
          />
        </Route>
        <Route path={"*"} element={<Navigate to={"/404"} />} />
      </Routes>
    </RestrictedArea>
  );
}
